module.exports = __webpack_public_path__ + "img/3068.8b18eb94.png";